import { Injectable} from '@angular/core';
import { Http, Headers, Response } from '@angular/http'; 
import { Globals } from '../_Globals/globals'; 

import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';


@Injectable()
export class UserService {
    constructor(private http: Http, private globals: Globals) {
        // set token if saved in local storage
        var currentUser = JSON.parse(localStorage.getItem('currentUser')); 
    } 

    getUsers(page: Number): Observable<any> { 
        return this.http.get(this.globals.api_url + 'users/api_user/page:' + page)
            .map(data => {
            data.json(); 
                return data.json();
        });
    }

    getAgencyUsers(page: Number): Observable<any> { 
        return this.http.get(this.globals.api_url + 'agency_users/index/page:' + page)
            .map(data => {
            data.json(); 
                return data.json();
        });
    }

    getRepoAgencyUsers(page: Number): Observable<any> { 
        return this.http.get(this.globals.api_url + 'agency_users/index/Repo Agency/page:' + page) 
            .map(data => {
            data.json(); 
                return data.json();
        });
    }

    addUser(data: any[]): Observable<any> { 
        return this.http.post(this.globals.api_url + 'users/add', data)
            .map(data => {
            data.json(); 
                return data.json();
        });
    }

    viewUser(id: Number): Observable<any> { 
        return this.http.get(this.globals.api_url + 'users/view_user/' + id)
            .map(data => {
            data.json(); 
                return data.json();
        });
    }

    getGroups(): Observable<any> { 
        return this.http.get(this.globals.api_url + 'apis/group')
            .map(data => {
            data.json(); 
                return data.json();
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/_Services/user.service.ts